/* AI Installatie below-the-fold — interactive logic
   Scope: #ai-install-page
   Data: window.AI_INSTALL_DATA
*/
(function () {
  if (!window.AI_INSTALL_DATA) return;

  const DATA = window.AI_INSTALL_DATA;
  const page = document.getElementById('ai-install-page');
  if (!page) return;

  const qa = (sel) => Array.from(page.querySelectorAll(sel));

  // ---- Real map via Leaflet + OpenStreetMap
  // Wait for Leaflet to load (deferred <script>)
  function initMap() {
    const mapEl = document.getElementById('ai-ip-leafletMap');
    if (!mapEl) return;
    if (typeof L === 'undefined') { setTimeout(initMap, 100); return; }

    const map = L.map(mapEl, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true,
    });

    // CartoDB Positron — minimal, light tiles that let brand pins pop
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      maxZoom: 19,
      subdomains: 'abcd',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> · <a href="https://carto.com/attributions">CARTO</a>',
    }).addTo(map);

    const brand = '#1556FF';
    const yellow = '#FFD500';
    const dark = '#0b1d4a';

    // Branded divIcon — a round CarOptions-blue badge with the wordmark "CO"
    function coIcon(active) {
      const bg = active ? yellow : brand;
      const fg = active ? dark : '#fff';
      const ring = active ? 'rgba(255,213,0,.35)' : 'rgba(21,86,255,.30)';
      return L.divIcon({
        className: 'ai-ip-pin',
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        popupAnchor: [0, -18],
        html:
          '<span class="ai-ip-pin-ring" style="box-shadow:0 0 0 6px ' + ring + '"></span>'
          + '<span class="ai-ip-pin-dot" style="background:' + bg + ';color:' + fg + '">'
          + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a8 8 0 0 0-8 8c0 5.5 8 12 8 12s8-6.5 8-12a8 8 0 0 0-8-8z"/><circle cx="12" cy="10" r="2.5" fill="currentColor" stroke="none"/></svg>'
          + '</span>',
      });
    }

    const points = [];
    const markers = [];
    DATA.variants.forEach((v, i) => {
      const coord = DATA.locationCoords[v.name] || DATA.locationCoords[v.name.split(' ')[0]];
      if (!coord) return;
      const marker = L.marker(coord, { icon: coIcon(false), title: 'CarOptions · ' + v.name }).addTo(map);
      marker.bindPopup(
        '<div class="ai-ip-pop">'
        + '<div class="ai-ip-pop-eyebrow">CarOptions · Servicepunt</div>'
        + '<div class="ai-ip-pop-name">' + v.name + '</div>'
        + '<div class="ai-ip-pop-sub">' + v.title + '</div>'
        + '<a href="#ai-ip-locations-sec" class="ai-ip-pop-btn">Kies deze locatie →</a>'
        + '</div>',
        { className: 'ai-ip-popup', closeButton: false, maxWidth: 240 }
      );
      marker.on('click', () => {
        markers.forEach(m => m.setIcon(coIcon(false)));
        marker.setIcon(coIcon(true));
      });
      points.push(coord);
      markers.push(marker);
    });

    if (points.length) {
      map.fitBounds(points, { padding: [30, 30] });
    } else {
      map.setView([52.1, 5.3], 7);
    }
  }
  initMap();

  // ---- Location cards click: scroll up to the theme's product form
  qa('#ai-ip-locGrid .ai-ip-loc-card').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = document.querySelector('form[action*="/cart/add"], .t4s-product-form, #AddToCartForm');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
})();
